export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(960)]: {
      display: "flex",
    },
  },
  root: {
    paddingBottom: 80,
    [theme.breakpoints.down(960)]: {
      paddingBottom: 50,
    },
  },
  appbarStyle: {
    backdropFilter: `blur(4px)`,
    background: "#17263d",
  },
  title: {
    textDecoration: "none",
    color: "#ffffff",
    fontSize: 24,
    "&:hover": { textDecoration: "none" },
  },
  buttonStyle: {
    display: "flex",
    justifyContent: "center",
  },
  desktopToolbar: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  headerPart: {
    display: "flex",
    justifyContent: "flex-start",
  },
  menuButton: {
    padding: 0,
    color: "black",
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(960)]: {
      display: "none",
    },
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  notificationAlert: {
    width: "60%",
    display: "flex",
    alignItems: "center",
    borderRadius: 25,
    fontSize: 20,
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  linkStyle: {
    textDecoration: "none",
    color: "#fff",
    "&:hover": { textDecoration: "underline" },
  },
});
